import React from "react";
import { Link } from "react-router-dom";

// First cell of a transaction list table (2026-09-12, standing rule): the
// thing people actually scan for - customer, supplier, employee - is the bold
// headline, and the transaction number (LPO-MOM-..., SO-..., TW-...) sits
// under it as smaller reference text. The number stays the link into the
// record, so nothing that used to be clickable stops being clickable.
//
// `secondary` falls back to being the headline when there is no party name,
// so a row never shows an empty bold line. `leading` is an optional small
// icon chip shown to the left (e.g. an LPO's purpose).
const PrimaryCell = ({ primary, secondary, to, extra, leading }) => {
  const headline = primary || secondary || "-";
  const showSecondary = primary && secondary;
  return (
    <div className="d-flex align-items-center gap-2" style={{ minWidth: 0 }}>
      {leading}
      <div style={{ minWidth: 0 }}>
        <div className="fw-semibold text-truncate" style={{ maxWidth: 320 }} title={typeof headline === "string" ? headline : undefined}>
          {!showSecondary && to ? <Link to={to}>{headline}</Link> : headline}
        </div>
        {(showSecondary || extra) && (
          <div className="small text-muted">
            {showSecondary && (to ? <Link to={to} className="text-muted">{secondary}</Link> : secondary)}
            {showSecondary && extra ? " · " : null}
            {extra}
          </div>
        )}
      </div>
    </div>
  );
};

export default PrimaryCell;
